declare const navigator: { userAgent: string };

export function isAndroidOrChrome(userAgent?: string) {
  try {
    return /android|chrome/i.test(
      userAgent || (navigator && navigator.userAgent)
    );
  } catch {
    return false;
  }
}
